import SalesforceService from "@/services/SalesforceService";
import { mapCompanyFields } from "@/state/modules/company";
import { mapUserFields } from "@/state/modules/user";

export default {
  computed: {
    ...mapCompanyFields(["accountId"]),
    ...mapUserFields([
      "bio",
      "email",
      "firstName",
      "groups",
      "lastName",
      "nickname",
      "phone",
      "title",
      "username",
    ]),
  },

  methods: {
    async getUserData(groups) {
      const user = this.$auth0.user.value;

      const username = user?.username || user.nickname || (user?.email ?? "");

      console.log(`Welcome, ${username || "guest"}!`);

      if (username) {
        this.username = username;
        this.groups = groups;

        this.email = user.email || "";
        this.firstName = user.given_name || "";
        this.lastName = user.family_name || "";
        this.nickname = user.nickname || "";

        const sfResponse = await SalesforceService.usernameLookup({
          cablelabsLogin: this.username,
        });

        if (sfResponse && sfResponse.data) {
          this.accountId = sfResponse.data.accountId;
          this.bio = sfResponse.data.bio;
          this.phone = sfResponse.data.phone;
          this.title = sfResponse.data.title;
        }
      }
    },
  },
};
